module.exports = __webpack_public_path__ + "static/media/splash-apps.8bb4af2c.svg";